// @format

export function showNotice(message = 'something went wrong',type = 'danger', delay = 8000): void {
  const app = $('.app').first();
  app.append(`<div class="notice alert alert-${type}" role="alert">${message}</div>`)
  const currentNotice = app.find('.notice.alert:last-child')
  setTimeout(()=>{currentNotice.remove()}, delay)
}